module.exports = __webpack_public_path__ + "8b7f83ac329f6b122ad42fe702a804ae.ttf";